import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Solution } from '../../_models/solution';
import { SolutionService } from '../../_services/solution.service';

@Component({
  selector: 'app-solution-list',
  templateUrl: './solution-list.component.html',
  styleUrls: ['./solution-list.component.css']
})
export class SolutionListComponent implements OnInit {

  solutions: Solution[];
  searchForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  page = 1;
  totalResults = 0;
  resultsPerPage = 0;

  constructor(private formBuilder: FormBuilder, private solutionService: SolutionService) { }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({ argument: [''] });

    this.get(this.page, this.searchForm.controls.argument.value);
  }

  onSubmit() {
    if (this.searchForm.invalid) {
      return;
    }

    this.page = 1;
    this.get(this.page, this.searchForm.controls.argument.value);
  }

  onSelectedPage() {
    this.get(this.page, this.searchForm.controls.argument.value);
  }

  private get(page: number, argument: string) {
    this.submitted = true;

    this.loading = true;
    this.solutionService.getSolutions(page, argument)
      .subscribe(
        data => {
          this.page = data.pageNumber;
          this.resultsPerPage = data.resultsPerPage;
          this.totalResults = data.totalResults;
          this.solutions = data.response;
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }
}
